import {createSlice} from '@reduxjs/toolkit';
import { StyleSheet } from 'react-native';

const initialState = {
  dynamicStyle: {}
};


const dynamicStyleSlice = createSlice({
    name: 'dynamicStyle',
    initialState,
    reducers: {
        resetDynamicStyle: () => initialState,
        updateDynamicStyle: (state, action) => {
            state.dynamicStyle = StyleSheet.create({...initialState.dynamicStyle, ...action.payload})
        }
    }
  });
  
  export const { resetDynamicStyle, updateDynamicStyle } = dynamicStyleSlice.actions;
  
  export default dynamicStyleSlice.reducer;
